import { Timestamp } from 'firebase/firestore'
import type { RecordTimestamps } from './firestoreTypes'

export function timestampValue(value: unknown): Timestamp | null {
  return value instanceof Timestamp ? value : null
}

export function timestampsFrom(data: Record<string, unknown>): RecordTimestamps {
  return {
    created_at: timestampValue(data.created_at),
    updated_at: timestampValue(data.updated_at),
  }
}

export function stringValue(value: unknown): string {
  return typeof value === 'string' ? value : ''
}

export function stringArrayValue(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : []
}

export function booleanValue(value: unknown, fallback = false): boolean {
  return typeof value === 'boolean' ? value : fallback
}

export function normalizePhone(value: string): string {
  const raw = value.trim()
  const compact = raw.replace(/[\s().-]/g, '')
  if (compact.startsWith('00')) return `+${compact.slice(2)}`
  const digits = compact.replace(/\D/g, '')
  if (!compact.startsWith('+') && digits.length === 10) return `+91${digits}`
  if (!compact.startsWith('+') && digits.length === 12 && digits.startsWith('91')) return `+${digits}`
  return compact
}

export function isValidPhone(value: string): boolean {
  return /^\+?[1-9]\d{6,14}$/.test(normalizePhone(value))
}
